import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { FooterManagerStore } from '#core/components/footer-manager/store/footer-manager.store';
import { SidenavStore } from '#core/components/sidenav/store/sidenav.store';
import { CampaignsFooterStore } from '#modules/campaigns/store/campaigns-footer.store';
import { ReviewsContext } from '#modules/reviews/contexts/reviews.context';
import { ReviewsStore } from '#modules/reviews/store/reviews.store';

export function provideSidenavScope(): EnvironmentProviders {
    return makeEnvironmentProviders([SidenavStore, CampaignsFooterStore, ReviewsContext, ReviewsStore, FooterManagerStore]);
}
